import { FormControl } from '@/components'
import { useEffect, useRef, useState } from 'react'

function SlideTabs ( prop ) {
    const { isDirect, setIsDirect, children } = prop
    const elementRef = useRef( null )
    const [ slideMargin, setSlideMargin ] = useState( 0 )
    const [ contentWidth, setContentWidth ] = useState( 0 )
    const [ isClick, setisClick ] = useState( false )
    const [ mouseDownClientX, setMouseDownClientX ] = useState( 0 )

    useEffect( () => {
        setSlideMargin( isDirect ? -elementRef.current.clientWidth : 0 )
    }, [ isDirect ] )

    const handleResize = () => {
        setContentWidth( elementRef?.current?.offsetWidth )
    }

    useEffect( ()=>{
        handleResize()
        window.addEventListener( 'resize', handleResize )
    }, [] )

    const onMouseDown = ( e ) =>{
        setisClick( true )
        setMouseDownClientX( e.clientX )
    }

    const onMouseMove = ( e ) => {
        if ( !isClick ) return

        const imgX = e.clientX - mouseDownClientX
        setSlideMargin( slideMargin + imgX / 1.5 )
    }

    const onMouseUp = ( e ) => {
        const imgX = e.clientX - mouseDownClientX
        setisClick( false )

        if ( imgX === 0 ) return setSlideMargin( slideMargin )

        imgX < 0 ? onClickDirect() : onClickCommon()
    }

    const onMouseOut=( e )=>{
        if ( !isClick ) return
        onMouseUp( e )
    }

    const onClickCommon = () =>{
        setSlideMargin( 0 )
        setIsDirect( false )
    }

    const onClickDirect = () =>{
        setSlideMargin( -contentWidth )
        setIsDirect( true )
    }

    return (
        <FormControl
            fullWidth
            ref={ elementRef }
            className="findWidth"
            sx={ { overflow:'hidden' } }
            onMouseDown={ ( e ) => onMouseDown( e ) }
            onMouseUp={ ( e ) => onMouseUp( e ) }
            onMouseOver={ ( e )=> onMouseOut( e ) }
            onMouseOut={ ( e )=> onMouseOut( e ) }
            onMouseMove={ ( e )=> onMouseMove( e ) }
        >
            <FormControl sx={ {
                marginLeft:`${ slideMargin }px`,
                width:'200%',
                flexDirection: 'row',
                overflow: '-moz-hidden-unscrollable'
            } }>
                { children && children }
            </FormControl>
        </FormControl>
    )
}

export default SlideTabs